import { render, staticRenderFns } from "./CareerSelect.vue?vue&type=template&id=23a86014&scoped=true&"
import script from "./CareerSelect.vue?vue&type=script&lang=js&"
export * from "./CareerSelect.vue?vue&type=script&lang=js&"
import style0 from "./CareerSelect.vue?vue&type=style&index=0&id=23a86014&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a86014",
  null
  
)

export default component.exports